import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../../pages/Student/Home";
import HelpSupport from "../../pages/Student/HelpSupport";
import SurveysComingSoon from "../SurveysComingSoon";
import Grades from "../../pages/Student/Grades";
import Feedback from "../../pages/Student/Feedback";
import Subjects from "../../pages/Student/Subjects";
import ToDo from "../../pages/Student/ToDo";
import ConnectChat from "../../pages/Student/ConnectChat";
import StudentRequests from "../../pages/Student/Requests";
import MyAssignments from "../../pages/LearningTasks/MyAssignments";
import ActionCards from "../../pages/Student/ActionCards";
import StudentWorkGallery from "../../pages/Student/WorkGalleryPage";

const StudentDashboard = () => (
  <Routes>
    <Route path="home" element={<Home />} />
    <Route path="grading" element={<Grades />} />
    <Route path="action" element={<ToDo />} />
    <Route path="connect" element={<ConnectChat />} />
    <Route path="subjects" element={<Subjects />} />
    <Route path="todo" element={<ToDo />} />
    <Route path="assignments" element={<MyAssignments audience="student" />} />
    <Route path="work-gallery" element={<StudentWorkGallery />} />
    <Route path="action-cards" element={<ActionCards />} />
    <Route path="help-support" element={<HelpSupport />} />
    <Route path="surveys" element={<SurveysComingSoon />} />
    <Route path="grades" element={<Grades />} />
    <Route path="feedback" element={<Feedback />} />
    <Route path="requests" element={<StudentRequests />} />
    <Route path="*" element={<Navigate to="home" />} />
  </Routes>
);

export default StudentDashboard;
